import { render } from "./EditThumbnailProduk.vue?vue&type=template&id=6b64824e"
import script from "./EditThumbnailProduk.vue?vue&type=script&lang=js"
export * from "./EditThumbnailProduk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__